import { Hourglass } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PolicyField } from "./PolicyField";
import type { PolicyCardProps } from "./policy-card.types";

// Spec 079 — a CARÊNCIA da apuração. Era variável de ambiente, declarada em dois serviços que
// precisavam concordar; virou coluna, e com um valor só divergir deixou de ser possível.
export function SettlementGraceCard({ register, errors, disabled }: PolicyCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Hourglass className="h-4 w-4 text-text-tertiary" aria-hidden />
          Carência da apuração
        </CardTitle>
      </CardHeader>
      <CardContent>
        <PolicyField
          id="policy-grace"
          label="Espera após o fim da vigência"
          unit="horas"
          hint="Quanto tempo a apuração de um cenário aplicado aguarda depois do fim da vigência. Existe porque produção e refugo chegam com atraso: apurar antes mediria a lacuna do registro, não a decisão."
          registration={register("settlementGraceHours", { valueAsNumber: true })}
          error={errors.settlementGraceHours}
          disabled={disabled}
        />
      </CardContent>
    </Card>
  );
}
